import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';

import { LayoutService } from '../../../services/layout.service';
import { ThemeService } from '../../../../shared/theme/services/theme.service';

@Component({
  selector: 'video-background',
  templateUrl: './video-background.component.html',
})
export class VideoBackgroundComponent implements OnInit, OnDestroy {

  public backgroundVideoEnabled: boolean = false;

  public videoSrc: string = null;

  private subscription: Subscription = new Subscription();
  private videoBackground: ElementRef;

  private themeDir: string;

  @ViewChild('themeVideo')
  private set preloadRef(element: ElementRef) {
    this.videoBackground = element;
    if (this.videoBackground) {
      this.videoBackground.nativeElement.load();
    }
  }

  /**
   * Constructor.
   *
   * @param layoutService
   * @param themeService
   */
  public constructor(private layoutService: LayoutService, private themeService: ThemeService) {

  }

  /**
   * Initialisation.
   *
   * @return void
   */
  public ngOnInit(): void {
    this.subscription.add(
      this.layoutService.disableBackgroundVideo
      .subscribe(
        (disabled: boolean) => {
          this.backgroundVideoEnabled = !disabled;
        },
      ),
    );

    this.subscription.add(
      this.themeService.getThemeChange()
        .subscribe((theme: string ) => {
          this.themeDir = this.themeService.assetsDir + theme;
          this.setVideoSrc();
        }),
    );

    this.subscription.add(
      this.themeService.getCustomThemeChange()
        .subscribe((customTheme: string ) => {
          if (customTheme) {
            this.themeDir = this.themeService.customAssetsDir + customTheme;
            this.setVideoSrc();
          }

        }),
    );
  }

  /**
   * When the component is destroyed, get rid of things.
   *
   * @returns void
   */
  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Set the video source
   *
   * @return void
   */
  private setVideoSrc(): void {
    this.videoSrc = this.themeDir + '/shared/video/background-default.mp4';
  }

}
